import { Button, IconButton, SvgIcon, Tooltip } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { trackAnalytics } from '@puffin/app-frame-api';
import { devToolsNavigationItem } from '../../routes/navigation';

const isDevToolsLocation = ({ pathname, hostname }: Pick<Location, 'pathname' | 'hostname'>): boolean =>
  pathname.startsWith('/pr-preview') || hostname === 'platformpuffin.local.meisterplan.dev';

export const DevToolsButton = ({ collapsed, onNavigate }: { collapsed: boolean; onNavigate?: () => void }) => {
  if (!isDevToolsLocation(window.location)) {
    return null;
  }

  const { label, path, icon } = devToolsNavigationItem;
  const onClick = () => {
    trackAnalytics('NAVIGATION_ITEM_SELECTED', { section: 'devtools', destination: path });
    onNavigate?.();
  };
  const buttonIcon = (
    <SvgIcon>
      <path d={icon} />
    </SvgIcon>
  );

  return collapsed ? (
    <Tooltip title={label} placement="right">
      <IconButton
        component={Link}
        to={path}
        aria-label={label}
        color="primary"
        onClick={onClick}
        sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', '&:hover': { bgcolor: 'primary.dark' } }}
      >
        {buttonIcon}
      </IconButton>
    </Tooltip>
  ) : (
    <Button component={Link} to={path} color="primary" variant="contained" fullWidth startIcon={buttonIcon} onClick={onClick}>
      {label}
    </Button>
  );
};
